var map = {
	"./pokdenggame_en.png": "Gnn6",
	"./pokdenggame_th.png": "Yzfl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MD3Y";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa ^\.\/pokdenggame_.*\.png$
// module id = MD3Y
// module chunks = 1